import { createDuck } from '@/utils'
import { getPostageInfo, getCartSummaryInfo, getSkeleton, getCredit } from '@/services/api/common'
import { SHOP_ID } from '@/utils/const'

export const duck = createDuck({
  name: 'commonDuck',
  initialState: {
    postage: null,
    coupons: [],
    /** @type CartSummaryInfo */
    cartSummary: {
      count: 0,
    },

    credit: 0,

    /** @type {Array<address.AddressItem>} */
    addressList: [],
    addressStatus: 0,
    searchData: [],
  },
  actions: {
    /**
     *
     * @param {*} activityIds
     * @returns
     */
    fetchPostage(activityIds) {
      return async dispatch => {
        const { data, error } = await getPostageInfo(SHOP_ID, activityIds)
        if (!error) {
          dispatch(
            duck.change({
              postage: { ...data },
            }),
          )
        }
      }
    },
    fetchCredit() {
      return async dispatch => {
        const { data, error } = await getCredit(SHOP_ID)
        if (!error) {
          dispatch(
            duck.change({
              credit: data,
            }),
          )
        }
      }
    },

    fetCartSummaryInfo() {
      return async dispatch => {
        const { data, error } = await getCartSummaryInfo(SHOP_ID)
        if (!error) {
          dispatch(
            duck.change({
              cartSummary: { ...data },
            }),
          )
        }
      }
    },

    fetchSkeleton() {
      return async (dispatch, getState) => {
        const { commonDuck } = getState()
        if (!Array.isArray(commonDuck.searchData) || commonDuck.searchData.length < 1) {
          const { data, error } = await getSkeleton()
          try {
            if (!error) {
              const d = JSON.parse(data) || {}
              dispatch(
                duck.change({
                  searchData: d.search && d.search.data,
                }),
              )
            }
          } catch (e) {
            console.log('e -----------', e)
          }
        }
      }
    },
  },
})
